import {Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {DatePipe, DecimalPipe} from '@angular/common';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {ApiService, BankingService, TargetAccount} from '../../../../../../projects/accounting/src/public_api';
import {EmailEditorComponent} from '../../../popups/email-editor/email-editor.component';
import {MessageBoxComponent, MessageBoxData} from '../../../../../../projects/jv-ui/src/public_api';
import {ASCIIPipe, CachingService, MailAccount, MailingDefault, MailingService, Scope, StorageService} from '../../../../../../projects/jv-common/src/public_api';

export interface DetailsEditorData {

  capitalId: number;
  name: string;
  address: string;
  period: string;

  debtToBrand: number;
  debtToWarehouses: number;

  debtOfSellingPoints: number;

  turnOverOfWarehouses: number;
  turnOverOfBrand: number;

  debtOfPoints: number;

  returned: number;
  turnOver: number;

  emails: Array<string>;
}

@Component({
  selector: 'details-editor',
  templateUrl: './details-editor.component.html',
  styleUrls: ['./details-editor.component.scss']
})
export class DetailsEditorComponent implements OnInit, OnDestroy {

  @Input() data: DetailsEditorData = null;

  @Output() closed: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() update: EventEmitter<Array<string>> = new EventEmitter<Array<string>>();
  @Output() sent: EventEmitter<boolean> = new EventEmitter<boolean>();
  message = '';

  Fees: any;
  Outlet = [];
  formData = {
    FeeID: null,
    Amount: null,
  };
  changed = false;
  loading = false;
  onAdd = false;
  Total = 0;

  email_debt_submissions = {};
  cacheKeyEmailDebt = 'accounting_email_debt_submissions';

  @ViewChild('content')
  content: ElementRef;
  @ViewChild('mail_warning')
  mail_warning: ElementRef;
  nextPeriod: string = this.date.transform(new Date(), "MM-yyyy");

  // private lu = ["19134652686688", "3171179999"]
  private lu = ["11001017958362"]

  public accounts: Array<TargetAccount> = this.banking.targets.filter(i => i.account != null && this.lu.indexOf(i.account) > -1);

  constructor(
    public modalRef: BsModalRef,
    private modalService: BsModalService,
    private api: ApiService,
    private decimal: DecimalPipe,
    private date: DatePipe,
    private ascii: ASCIIPipe,
    private storage: StorageService,
    private mailing: MailingService,
    private banking: BankingService,
    private cache: CachingService,
  ) {
  }

  ngOnInit() {
    this.load();
  }

  async load(){
    this.loading = true;
    await this.api.debtOfOutlet({ ID: this.data.capitalId, Period: this.data.period }).toPromise().then(response => {
      if (response.succeed) {
        this.Outlet = response.data.filter(i => i.Total != 0);
        this.Fees = response.data.filter(i => i.Total == 0);
        this.Outlet.forEach(i => {
          this.Total += i.Total;
        });
      }
    });
    await this.cache.get(this.cacheKeyEmailDebt, {}, Scope.USER).subscribe( rs => {
      if (rs){
        this.email_debt_submissions = rs;
        console.log('init',rs);
      }
    });
    this.loading = false;
  }

  ngOnDestroy(): void {
    this.closed.emit(this.changed);
  }

  reload() {
    this.api.debtOfOutlet({ ID: this.data.capitalId, Period: this.data.period }).subscribe(response => {
      if (response.succeed) {
        this.Outlet = response.data.filter(i => i.Total != 0);
        this.Fees = response.data.filter(i => i.Total == 0);
        this.Total = 0;
        this.Outlet.forEach(i => {
          this.Total += i.Total;
        });

        this.changed = true;
        this.onAdd = false;
      }
      this.loading = false;
    })
  }

  commit() {
    if (this.formData.FeeID == null) {
      this.message = 'Bạn chưa chọn loại phí';
      return;
    }
    if (this.formData.Amount <= 0) {
      this.message = 'Số tiền không hợp lệ';
      return;
    }
    let feeApplicationRequest = {
      FeeID: parseInt(this.formData.FeeID),
      CapitalID: this.data.capitalId,
      Amount: this.formData.Amount,
      Date: '01-' + this.data.period
    };
    this.loading = true;
    this.api.feeApply(feeApplicationRequest).subscribe(rs => {
      if (rs) {
        this.reload();
      }
    });
  }

  remove(i) {
    if (i.Deletable == true) {

      let html = '';

      html += '<div class="text-center">';
      html += 'Bỏ <span class="text-danger">' + i.Name + '</span> của <span class="text-danger">' + this.data.address + '</span>?</div>';

      let data: MessageBoxData = {
        title: 'Xác nhận xóa phí áp dụng cho cửa hàng',
        content: html,
        buttons: [
          { name: 'Đồng ý', class: 'ecg-bg-green-dark' },
          { name: 'Không', class: 'ecg-bg-warning-dark' }
        ]
      };

      this.modalService
        .show(MessageBoxComponent, { class: 'modal-md', initialState: { data: data } })
        .content.selected.subscribe(button => {

          if (button != data.buttons[0]) return;

          let request = {
            FeeID: parseInt(i.FeeID),
            CapitalID: this.data.capitalId,
            Since: '01-' + this.data.period
          };

          this.loading = true;

          if (request.FeeID > 0) {
            this.api.feeRemove(request).subscribe(response => {
              if (response) this.reload();
            })
          }
          else {
            this.api.deleteTurnOver({ ID: this.data.capitalId, Period: this.data.period }).subscribe(response => {
              if (response.succeed && response.data) {
                this.data.debtToBrand -= i.Total;
                this.reload();
              }
            })
          }
        })
    }
  }

  rest() {

    let left = this.data.debtToWarehouses + this.data.debtOfSellingPoints + this.data.turnOverOfBrand + this.data.turnOverOfWarehouses + this.Total - this.data.returned - this.data.turnOver - this.data.debtOfPoints;

    if (Math.round(left) <= 0) {
      return '0';
    }

    if (Math.round(left) > 10000) {
      return '<b class="text-danger">' + this.decimal.transform(left, '1.0-0', 'en-US') + '</b>';
    }

    return this.decimal.transform(left, '1.0-0', 'en-US');
  }
  getKey(){
    return '#' + this.data.period +'_'+ this.data.capitalId;
  }
  getSubmissionInfo(){
    if (this.email_debt_submissions != null && typeof this.email_debt_submissions[this.getKey()] != 'undefined'){
        return {
          value: this.email_debt_submissions[this.getKey()],
          class: 'ecg-bg-danger-dark',
          txt: 'Gửi cảnh báo lần ' + (this.email_debt_submissions[this.getKey()]),
        };
    }
    return {
      value: 1,
      class: 'ecg-bg-warning-dark',
      txt: 'Gửi cảnh báo lần 1'
    }
  }
  async mail() {

    let config = {
      class: 'modal-md',
      initialState: {
        data: {
          title: 'Chi tiết công nợ tháng ' + this.data.period + ' ' + this.data.address,
          emails: this.data.emails
        }
      }
    };

    this.modalService.show(EmailEditorComponent, config).content.send.subscribe(emails => {
      this.loading = true;

      this.data.emails = emails;
      this.update.emit(emails);

      let payload = {
        receivers: emails,
        account: MailAccount.Accountant,
        name: 'Kế Toán AHA',
        subject: 'Chi tiết công nợ tháng ' + this.data.period + ' ' + this.data.address + (this.getSubmissionInfo().value > 1 ? '(Yêu cầu thanh toán lần ' + this.getSubmissionInfo().value + ')' : ''),
        content: this.content.nativeElement.innerHTML,
        css: MailingDefault.Style
      };
      this.mailing.send(payload, succeed => {
            this.loading = false;
            this.sent.emit(succeed);
            this.modalService.show(MessageBoxComponent, {
              class: 'modal-md', initialState: {
                data: {
                  content: succeed ? '<b class="text-title">Thông tin đã được gửi tới </b><br><div class="text-primary">' + emails.join(', ') + '</div>' : '<div class="text-danger text-center"><b>Có lỗi không gửi được mail, vui lòng thử lại</b></div>',
                  buttons: [{ name: 'OK', class: succeed ? 'bg-success' : 'bg-danger' }]
                }
              }
            });
      });
    });
  }
  async mailWarning(){
    let config = {
      class: 'modal-md',
      initialState: {
        data: {
          title: 'Chi tiết công nợ tháng ' + this.data.period + ' ' + this.data.address,
          emails: this.data.emails
        }
      }
    };

    this.modalService.show(EmailEditorComponent, config).content.send.subscribe(emails => {
      this.loading = true;

      this.data.emails = emails;
      this.update.emit(emails);

      let payload = {
        receivers: emails,
        account: MailAccount.Accountant,
        name: 'Kế Toán AHA',
        subject: 'Chi tiết công nợ tháng ' + this.data.period + ' ' + this.data.address + (this.getSubmissionInfo().value > 1 ? '(Yêu cầu thanh toán lần ' + this.getSubmissionInfo().value + ')' : ''),
        content: this.mail_warning.nativeElement.innerHTML,
        css: MailingDefault.Style
      };

      this.mailing.send(payload, succeed => {
        let tempEmailDebtSubmissions = JSON.parse(JSON.stringify(this.email_debt_submissions));
        let key = this.getKey();
        if(typeof  tempEmailDebtSubmissions[key] != 'undefined'){
          tempEmailDebtSubmissions[key] ++;
        }else{
          tempEmailDebtSubmissions[key] = 1;
        }
        this.cache.set(this.cacheKeyEmailDebt, tempEmailDebtSubmissions, Scope.USER).subscribe( rs => {
          if(rs){
            this.email_debt_submissions = tempEmailDebtSubmissions;
          }
          this.loading = false;
          this.sent.emit(succeed);
          this.modalService.show(MessageBoxComponent, {
            class: 'modal-md', initialState: {
              data: {
                content: succeed ? '<b class="text-title">Thông tin đã được gửi tới </b><br><div class="text-primary">' + emails.join(', ') + '</div>' : '<div class="text-danger text-center"><b>Có lỗi không gửi được mail, vui lòng thử lại</b></div>',
                buttons: [{ name: 'OK', class: succeed ? 'bg-success' : 'bg-danger' }]
              }
            }
          });
        });
      });
    });
  }
  getFirstCharacters(txt: string): string {
    let res = '';
    if (typeof txt != "undefined") txt.split(' ').forEach(i => res += i.length > 0 ? i[0] : '');
    return res;
  }

  getDateSyntax() {
    let parts = this.date.transform(new Date(), 'dd-MM-yyyy').split('-');
    return 'ngày ' + parts[0] + ' tháng ' + parts[1] + ' năm ' + parts[2];
  }

  getMonthSyntax() {
    return this.date.transform(new Date(), 'MM/yyyy');
  }
  getMailDate(){
    let d: any = this.data.period.split('-');
    return 'T' + Math.floor(d[0]) + ' ' + d[1];
  }
}
